import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import withRouterCustom from 'utils/hoc/withRouterCustom'
import { withLaunchDarkly } from 'utils/sdks/launchDarkly.v2'
import { withMixpanel } from 'utils/sdks/mixpanel'

import { withOrderPaymentRecords } from 'payments/payments.queries'
import {
  allowInvoiceRetailers,
  getAccountId,
} from 'store/currentUser/selectors'
import { sortOrders } from 'store/orderList/actions'
import { getSelectedQuickFilters } from 'store/quickFilters/selectors'

import { withAnalytics } from './OrderTable.analytics'
import OrderTable from './OrderTable.component'
import { withFormatter } from './OrderTable.formatter'
import withPermissions from './OrderTable.permissions'
import withOrderManualPaymentRecords from './withOrderManualPaymentRecords'

const mapStateToProps = (state) => ({
  orderBy: state.orderList.orderBy,
  accountId: getAccountId(state),
  permissions: {
    allowInvoiceRetailers: allowInvoiceRetailers(state),
  },
  selectedFilters: getSelectedQuickFilters(state),
})

const mapDispatchToProps = {
  sortOrders,
}

const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withRedux,
  withMixpanel,
  withRouterCustom,
  withAnalytics,
  withLaunchDarkly,
  withPermissions,
  withOrderPaymentRecords,
  withOrderManualPaymentRecords,
  withFormatter,
)(OrderTable)
